import { useEffect, useState } from "react";
import { getVariantValue } from "../utils/variantTunnel";

export const useVariantTunnel = (): string | null => {
  const [variant, setVariant] = useState<string | null>(getVariantValue);

  useEffect(() => {
    const handler = (): void => {
      const variantValue = getVariantValue();
      setVariant(variantValue);
    };

    window.addEventListener("storage", handler);
    return () => window.removeEventListener("storage", handler);
  }, []);

  useEffect(() => {
    const POLLING_DURATION_SEC = 60 * 1000;
    const timerId = setInterval(
      () => setVariant(getVariantValue()),
      POLLING_DURATION_SEC,
    );
    return () => clearInterval(timerId);
  }, []);

  return variant;
};
